import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import css from './ContactUsPage.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { Footer, LayoutSingleColumn, Modal, Page, H1, H3, NamedLink } from '../../components';
import { contactUsMessage, getStrapiContactUsContent } from '../../util/api';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withViewport } from '../../util/uiHelpers';
import { types as sdkTypes } from '../../util/sdkLoader';
import ContactUsForm from '../ContactUsPage/ContactUsForm/ContactUsForm';
import Slider from "react-slick";
// import { css } from '@emotion/react';
// import { RingLoader } from "react-spinners";

const { Money } = sdkTypes;

const ContactUsPageComponent = props => {
  const {
    intl,
    scrollingDisabled,
    currentUser,
    userShowError,
    userId,
    onCreateListingDraft,
  } = props;

  const [isSendMail, setIsSendMail] = useState(false);
  const [contactUsContent, setContactUsContent] = useState(false);
  const [contactSubmitModal, setContactSubmitModal] = useState(false);
  const [loading, setLoading] = useState(true); 
  const title = intl.formatMessage({ id: 'ContactUsPage.title' });

  useEffect(() => {
    fetchContactUsContent();
  }, []);

  const fetchContactUsContent = async () => {
    try {
      const res = await getStrapiContactUsContent({});
      setContactUsContent(res?.data?.attributes?.Videos?.data ?? []);
      setLoading(false); // After fetching content, set loading to false
    } catch (err) {
      console.log(err, '&&& &&& => err');
    }
  };

  const handleSubmit = values => {
    const { fullName, email, enquiry } = values;

    contactUsMessage({
      fullName,
      email,
      enquiry,
      senderId: 'info@myfindor.com',
      customerId: 'info@myfindor.com',
      subject: 'MyFindor Support',
      text: 'text',
      supportEmail: 'supportEmail',
    }).then(
      res => {
        setIsSendMail(true);
        setTimeout(() => {
          setIsSendMail(false);
        }, 3000);
      },
      error => {
        console.error(error);
        if (error) {
          console.error(error);
        }
      }
    );
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <Page className={css.root} title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        className={css.contactMain}
        topbar={
          <>
            <TopbarContainer currentPage="UserSendInvitation" />
          </>
        }
        footer={<FooterContainer />}
      >
        <div>
          <div className={css.contactWrapper}>

            <>
              {isSendMail ? (
                <div className={css.successMessage}>Invitation sent successfully</div>
              ) : null}
              <div className={css.mainWrapperContact}>
                <div className={css.sliderWrapper}>
                  {loading ? (
                    <div className={css.loaderWrapper}>
                      <span className={css.loader}></span>
                    </div>
                  ) : (
                    <Slider {...settings}>
                      {contactUsContent && contactUsContent !== 0 &&
                        contactUsContent?.map((items, index) => {
                          const url = items?.attributes?.url;
                          const mime = items?.attributes?.mime;
                          if (url) {
                            return (
                              <div key={index} className={css.slideVideo}>
                                <video 
                                autoPlay 
                                loop 
                                muted 
                                playsInline name="media" 
                                webkit-playsinline="true"
                                controls={false}>
                                <source src={url} type={mime} />
                                </video>
                              </div>
                            )
                          }
                        })
                      }
                    </Slider>
                  )}
                </div>
                <ContactUsForm className={css.form} onSubmit={handleSubmit} isSendMail={isSendMail} />
              </div>
            </>

          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactUsPageComponent.defaultProps = {
  rootClassName: null,
  className: null,
};

ContactUsPageComponent.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onCreateListingDraft: (values, config) => dispatch(requestCreateListingDraft(values, config)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});
const ContactUsPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(ContactUsPageComponent);

export default injectIntl(ContactUsPage);
